/* eslint-disable no-unused-vars */
import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import './styles/global.css'
import App from './App'
import { store } from './store/store.js'
import { Provider } from 'react-redux'
import { notificationService } from './features/notificationService';
import { AuthProvider } from './contexts/AuthContext.jsx';
import './utils/globalErrorHandler'; // Import pour activer les gestionnaires d'erreurs globaux


const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Provider>
  </React.StrictMode>
)